import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)

var router = new Router({
    routes:[
        {
            path:'/',
            redirect:'/main'
        },
        {
            path: '/main',
            name:'main',
            component:()=> import ('@/views/main'),
            meta:{
                title:'活动模板'
            }
        },
        // {
        //     path:'/dream',
        //     name: 'dream',
        //     component: () => import ('@/views/dreamWorkshop'),
        //     meta:{
        //         title:'梦工场大冒险'
        //     }
        // },
        // {
        //     path:'/songsong',
        //     name: 'song',
        //     component: () => import ('@/views/songsong'),
        //     meta:{
        //         title:'松松总动员'
        //     }
        // },
		{
		    path:'/paradiseAppt', //233乐园预约
		    name: 'paradiseAppt',
		    component: () => import ('@/views/paradiseAppt'),
		    meta:{
		        title:'游戏预约'
		    }
		},
		{
		    path:'/smallGameAppt', //233小游戏预约
		    name: 'smallGameAppt',
		    component: () => import ('@/views/smallGameAppt'),
		    meta:{
		        title:'游戏预约'
		    }
		},
		{
		    path:'/share',
		    name: 'share',
		    component: () => import ('@/views/share'),
		    meta:{
		        title:'游戏预约'
		    }
		},
		{
		    path:'/gameList',
		    name: 'gameList',
		    component: () => import ('@/views/gameList'),
		    meta:{
		        title:'游戏预约'
		    }
        },
        {
		    path:'/recommend', // 游戏主推
		    name: 'recommend',
		    component: () => import ('@/views/recommend'),
		    meta:{
		        title:'游戏主推'
		    }
		},
		{
		    path:'/justGunfight', // 正义抢战
		    name: 'justGunfight',
		    component: () => import ('@/views/justGunfight'),
		    meta:{
		        title:'正义抢战'
		    }
		},
		{
		    path:'/celebration', // 中秋国庆活动
		    name: 'celebration',
		    component: () => import ('@/views/celebration'),
		    meta:{
		        title:'中秋国庆活动'
		    }
		},
		{
		    path:'/hallowmas', // 万圣节活动
		    name: 'hallowmas',
		    component: () => import ('@/views/hallowmas/index'),
		    meta:{
				title:'万圣节活动'
			}
		},
		{
		    path:'/sakura', // 樱花校园活动
		    name: 'sakura',
		    component: () => import ('@/views/sakura'),
		    meta:{
		        title:'樱花校园'
		    }
		},
		{
		    path:'/recruitApplyForm', // 圈主招募活动-申请表单
		    name: 'recruitApplyForm',
		    component: () => import ('@/views/recruitApplyForm'),
		    meta:{
		        title:'圈主招募'
		    }
		},
		{
		    path:'/recruitActive', // 圈主招募活动-玩家圈主招募
		    name: 'recruitActive',
		    component: () => import ('@/views/recruitActive'),
		    meta:{
		        title:'玩家圈主招募'
		    }
		},
		{
		    path:'/redEnvelopes', // 红包拉新活动
		    name: 'redEnvelopes',
		    component: () => import ('@/components/redEnvelopesModal'),
		    meta:{
		        title:'欢乐齐分享 邀请赚红包'
		    }
		},
		{
		    path:'/redEnvelopes/withdrawal', // 红包拉新活动-提现
		    name: 'withdrawal',
		    component: () => import ('@/components/redEnvelopesModal/withdrawal'),
		    meta:{
		        title:'提现'
		    }
		},
		{
		    path:'/redEnvelopes/myWithdrawal', // 红包拉新活动-我的提现
		    name: 'myWithdrawal',
		    component: () => import ('@/components/redEnvelopesModal/myWithdrawal'),
		    meta:{
		        title:'我的提现'
		    }
		},
		{
		    path:'/redEnvelopes/rule', // 红包拉新活动-活动规则
		    name: 'rule',
		    component: () => import ('@/components/redEnvelopesModal/rule'),
		    meta:{
		        title:'邀好友、得红包'
		    }
		},
		{
		    path:'/redEnvelopes/ground', // 红包拉新活动-分享落地页
		    name: 'toGround',
		    component: () => import ('@/components/redEnvelopesModal/toGround'),
		    meta:{
		        title:'欢乐齐分享、邀请赚红包'
		    }
		},
		{
		    path:'/teamDraw', // 组队开盲盒、免费赢皮肤
		    name: 'TeamDraw',
		    component: () => import ('@/views/teamDraw'),
		    meta:{
		        title:'组队开盲盒、免费赢皮肤'
		    }
		},
		{
		    path:'/sakuraBox', // 樱花校园盒子
		    name: 'SakuraBox',
		    component: () => import ('@/views/sakuraBox/index'),
		    meta:{
		        title:'樱花校园盒子'
		    }
		},
		{
		    path:'/sakuraBoxDetail', // 樱花校园盒子详情
		    name: 'SakuraBoxDetail',
		    component: () => import ('@/views/sakuraBox/detail'),
		    meta:{
		        title:'存档详情'
		    }
		},
		{
		    path:'/sakuraBoxMyRecord', // 樱花校园盒子我的收藏
		    name: 'SakuraBoxMyRecord',
		    component: () => import ('@/views/sakuraBox/myRecordList'),
		    meta:{
		        title:'我的存档'
		    }
		},
		{
		    path:'/sakuraBoxApp', // 樱花校园盒子-app
		    name: 'SakuraBoxApp',
		    component: () => import ('@/views/sakuraBoxApp/index'),
		    meta:{
		        title:'樱花校园盒子'
		    }
		},
		{
		    path:'/sakuraBoxDetailApp', // 樱花校园盒子详情-app
		    name: 'SakuraBoxDetailApp',
		    component: () => import ('@/views/sakuraBoxApp/detail'),
		    meta:{
		        title:'存档详情'
		    }
		},
    ]
})
router.beforeEach((to, from, next) => {
    next();
    
    /* 路由发生变化修改页面title */
    if (to.meta.title && to.meta.title != '活动模板') {
        document.title = to.meta.title;
    }
});
export default router